import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import Seo from "../../components/seo"
import { graphql } from "gatsby"
import Line from "../../images/line.svg"

const ReisenList = (props) => {
  var länder = []

  return (
    <ul className="list-ul">
      {props.reisen.map((reise) => {
        if (länder.includes(reise.node.land)) {
          var nichtAnzeigen = true
        }
        länder += reise.node.land
        return (
          <li key={reise.node.id} className="reise">
            <div className={nichtAnzeigen ? "no-display" : "reise-land"}>
              {reise.node.land}
            </div>
            {reise.node.id !== "cd30c071-88bb-51bf-a70e-698c593d5cab" && (
              <div className="reise-card">
                <Link
                  to={reise.node.land.toLowerCase() + "/" + reise.node.slug}
                  className="reise-thumbnail"
                >
                  <GatsbyImage
                    image={reise.node.heroImage.gatsbyImageData}
                    className="thumbnail-container"
                  />
                </Link>
                <div className="reise-card-text">
                  <h2>{reise.node.destination}</h2>
                  <div className="kurzbeschreibung">
                    {reise.node.kurzbeschreibung}
                  </div>
                  <div className="buchen-button-big-list w-fit">
                    <Link
                      to={reise.node.land.toLowerCase() + "/" + reise.node.slug}
                      className="buchen-button-big-link buchen-button-big-link-wanderreise-liste"
                    >
                      {reise.node.id == "d75f92ad-f4cb-538d-95c9-32409e5aa265"
                        ? `Zum Angebot „Operated by Idealtours“`
                        : "Zum Angebot"}
                    </Link>
                    {reise.node.id ==
                      "d75f92ad-f4cb-538d-95c9-32409e5aa265" && (
                      <Link
                        to={"griechenland/kefalonia-rhomberg"}
                        className="buchen-button-big-link buchen-button-big-link-wanderreise-liste mt-2"
                      >
                        Zum Angebot „Operated by Rhomberg“
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            )}
          </li>
        )
      })}
    </ul>
  )
}

const WanderreisenPage = ({ data }) => {
  return (
    <Layout>
      <Seo title="Wanderreisen" />
      <div className="reisen-liste-headline">
        <h1>
          Wander
          <wbr />
          reisen
        </h1>
        <img className="line" src={Line} alt="Trennlinie"></img>
      </div>
      <div className="reisen-liste-container">
        <ReisenList reisen={data.wanderreisen.edges} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    wanderreisen: allContentfulReise(
      filter: { typ: { eq: "Wanderreise" } }
      sort: { fields: land, order: ASC }
    ) {
      edges {
        node {
          id
          land
          flagge
          destination
          kurzbeschreibung
          slug
          heroImage {
            gatsbyImageData(width: 735, layout: CONSTRAINED)
          }
        }
      }
    }
  }
`

export default WanderreisenPage
